import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — password field with show/hide toggle.
 * Preserves the ANGOLAUK+ dark auth-page styling by default.
 * Pass `variant="light"` for use on white backgrounds.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { value, onChange, placeholder, required, minLength, testid, variant = "dark", ...rest },
  ref
) {
  const [visible, setVisible] = useState(false);

  const base =
    variant === "light"
      ? "w-full pl-4 pr-11 py-3 rounded-xl bg-zinc-50 border border-zinc-200 text-black placeholder-zinc-400 outline-none focus:border-black transition-colors"
      : "w-full pl-4 pr-11 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/40 outline-none focus:border-[#c8102e] transition-colors";

  const iconColor = variant === "light" ? "text-zinc-500 hover:text-black" : "text-white/60 hover:text-white";

  return (
    <div className="relative">
      <input
        ref={ref}
        data-testid={testid}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        minLength={minLength}
        autoComplete={rest.autoComplete || (visible ? "off" : "current-password")}
        className={base}
        {...rest}
      />
      <button
        type="button"
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Ocultar palavra-passe" : "Mostrar palavra-passe"}
        aria-pressed={visible}
        className={`absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md ${iconColor} transition-colors focus:outline-none focus:ring-2 focus:ring-[#c8102e] focus:ring-offset-1`}
        tabIndex={-1}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
});

export default PasswordInput;
